<template>
  <div class="start">
    <Header />
    <Hero />
    <Start />
    <!--<Edit/>-->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import Start from '@/components/Start.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'StartView',
  components: {
    Header,
    Hero,
    Start,
    // Edit,
    Footer
  },
  data() {
    return {}
  },
  mounted() {
    localStorage.removeItem('vuex');
    this.$store.dispatch('resetRunTimeState');
    this.$store.state.reservationType = null;
    this.$store.state.reservationNr = null;
    this.$store.state.edit_data = null;
    this.$store.state.edit_slots = [];
    this.$store.state.edit_date = null;

    window.scrollTo(0, 0);
  }
}
</script>
